import { isPropertyGroupRecord } from './isPropertyGroupRecord';
export const hideStrategyProperties = ({
  originalFields,
  propertiesToHide
}) => {
  const propertySet = new Set(propertiesToHide);

  // Remove the properties from the originalFields list that are in the propertiesToHide list.
  const filteredFields = originalFields.filter(prop => !propertySet.has(prop.get('name', '')));
  return filteredFields.map(prop => {
    if (isPropertyGroupRecord(prop)) {
      return prop.update('properties', properties => {
        return properties.filter(nestedProperty => !propertySet.has(nestedProperty.get('name')));
      });
    } else return prop;
  }).toMap();
};